import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import Tooltip from '../Tooltip';

const CircleShadow = (
  { children,
    onClick,
    className,
    noBackground = false,
    darkMode = false,
    visible = true,
    display = true,
    tooltipText = false,
    style = {} }
) => {
  const classes = classnames('circle-shadow', className, {
    hidden: !visible, 'd-none': !display, inverse: darkMode, 'no-background': noBackground });
  const tooltipId = uuidv1();

  return (
    <Fragment>
      <span className={classes} onClick={onClick} onKeyDown={onClick} style={style} data-tip data-for={tooltipId}>
        {children}
      </span>
      {
        tooltipText && (
        <Tooltip id={tooltipId} place="bottom">
          {tooltipText}
        </Tooltip>
        )}
    </Fragment>
  );
};

CircleShadow.propTypes = {
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool,
  display: PropTypes.bool,
  darkMode: PropTypes.bool,
  noBackground: PropTypes.bool
};

export default CircleShadow;
